import { Sparkles } from "lucide-react";

export const ProPractBadge = ({ className = "", dark = false, href }) => {
  const classes = `inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] font-outfit font-semibold uppercase tracking-wider ${
    dark
      ? "border-gold/40 bg-gold/10 text-gold"
      : "border-terra/30 bg-terra/10 text-terra"
  } ${href ? "transition-opacity hover:opacity-75 " : ""}${className}`;
  const inner = (
    <>
      <Sparkles className="h-3 w-3" />
      Powered by ProPract
    </>
  );
  if (href) {
    return (
      <a data-testid="propract-badge" href={href} target="_blank" rel="noopener" aria-label="Bookings powered by ProPract" className={classes}>
        {inner}
      </a>
    );
  }
  return (
    <span data-testid="propract-badge" className={classes}>
      {inner}
    </span>
  );
};
